<div [formGroup]="form">
    <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
            <mat-panel-title class="fw-normal">Search Form</mat-panel-title>
        </mat-expansion-panel-header>
        <div formArrayName="dynamicFields">
            @for (dynamicField of searchDynamicFields.controls; track dynamicField) {
                <app-dynamic-field-form
                    [form]="dynamicField"
                    [id]="$index"
                    [showDeleteButton]="false"
                    [showDisabledToggle]="false"
                    (onDelete)="deleteDynamicField($event)"
                    [isPersistent]="true"
                ></app-dynamic-field-form>
            }
        </div>
        <div class="mb-3">
            <mat-slide-toggle id="enable-search-by-flight-number" formControlName="enableSearchByFlightNumber">
                Enable search by flight number
            </mat-slide-toggle>
        </div>
        <mat-form-field appearance="outline" class="w-100 mb-3">
            <mat-label>Facility source</mat-label>
            <input matInput formControlName="facilitySource" id="facility-source" type="text" />
        </mat-form-field>
        <app-input-customization></app-input-customization>
        <app-background-image-upload
            [formGroup]="form"
            [images]="orgBackgroundImages"
            [removeShadowControl]="removeShadowControl"
        ></app-background-image-upload>
    </mat-expansion-panel>
</div>
